import React from "react";
import { Download, Apple } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { trackEvent } from "../lib/analytics";

const PLAY_URL = "https://play.google.com/store/apps/details?id=fi.duunari.app";
const APPSTORE_URL = "https://apps.apple.com/app/duunari-app/id6779275969";

/**
 * Unified primary download buttons — equal siblings.
 * Both yellow filled, same size, same hazard-hover effect.
 */
export const DownloadButtons = ({ testIdPrefix = "hero" }) => {
  const { t } = useLanguage();
  return (
    <div
      data-testid={`${testIdPrefix}-download-buttons`}
      className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-xl mx-auto"
    >
      <DownloadButton
        href={PLAY_URL}
        external
        Icon={Download}
        label={t("cta.download_android")}
        testId={`${testIdPrefix}-android-play-button`}
        onClick={() => trackEvent("Click: Google Play")}
      />
      <DownloadButton
        href={APPSTORE_URL}
        external
        Icon={Apple}
        label={t("cta.download_ios")}
        testId={`${testIdPrefix}-ios-button`}
        onClick={() => trackEvent("Click: App Store")}
      />
    </div>
  );
};

const DownloadButton = ({ href, external, Icon, label, testId, onClick }) => {
  return (
    <a
      href={href}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
      data-testid={testId}
      onClick={onClick}
      className="btn-hazard group relative inline-flex items-center justify-center gap-3 h-16 px-6 bg-[#FFEA00] text-black font-display font-bold uppercase tracking-wider border-2 border-[#FFEA00] hard-shadow"
    >
      <Icon className="w-6 h-6 stroke-[2.5] shrink-0" />
      <span className="text-base sm:text-lg whitespace-nowrap">{label}</span>
    </a>
  );
};
